var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { LayoutDiv, RowWrapper } from './styles';
import { GUTTER } from '../../utilities/grid';
export var Layout = function (_a) {
  var children = _a.children,
    _b = _a.gutter,
    gutter = _b === void 0 ? GUTTER['tablet'] : _b,
    _c = _a.mode,
    mode = _c === void 0 ? 'grid' : _c,
    _d = _a.paddingTop,
    paddingTop = _d === void 0 ? 40 : _d,
    _e = _a.width,
    width = _e === void 0 ? 12 : _e,
    restOfProps = __rest(_a, ["children", "gutter", "mode", "paddingTop", "width"]);
  return _jsx(LayoutDiv, __assign({
    gutter: gutter,
    mode: mode,
    paddingTop: paddingTop,
    width: width
  }, restOfProps, {
    children: _jsx(RowWrapper, __assign({
      gutter: gutter,
      mode: mode,
      paddingTop: paddingTop,
      width: width
    }, restOfProps, {
      children: children
    }))
  }));
};